/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaButtonIcon/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TysiaButtonIcon({
  children,
  viewPath = "/DesignSystem/TysiaButton/TysiaButtonIcon",
  marginLeft,
  marginRight,
  type,
  hovered,
  selected,
  disabled
  
}) {
let dtTysiabuttoniconFillPrimaryActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.primary.active'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtTysiabuttoniconFillPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.primary.hovered'
        })
let dtTysiabuttoniconFillPrimarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.primary.selected'
        })
let dtTysiabuttoniconFillPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.primary.disabled'
        })
let dtTysiabuttoniconFillSecondaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.secondary.hovered'
        })
let dtTysiabuttoniconFillSecondarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.secondary.selected'
        })
let dtTysiabuttoniconFillSecondaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.secondary.disabled'
        })
let dtTysiabuttoniconFillSecondaryActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.secondary.active'
        })
let dtTysiabuttoniconFillCriticalHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.critical.hovered'
        })
let dtTysiabuttoniconFillCriticalSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.critical.selected'
        })
let dtTysiabuttoniconFillCriticalDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.critical.disabled'
        })
let dtTysiabuttoniconFillCriticalActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.critical.active'
        })
let dtTysiabuttoniconFillGhostActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.ghost.active'
        })
let dtTysiabuttoniconFillGhostHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.ghost.hovered'
        })
let dtTysiabuttoniconFillGhostSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.ghost.selected'
        })
let dtTysiabuttoniconFillGhostDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonIcon.fill.ghost.disabled'
        })
  return (<React.Fragment
>
<Children
  viewPath={`${viewPath}/Children`}
 fill={type === "primary" && hovered ? dtTysiabuttoniconFillPrimaryHovered : type === "primary" && selected ? dtTysiabuttoniconFillPrimarySelected : type === "primary" && disabled ? dtTysiabuttoniconFillPrimaryDisabled : type === "primary" ? dtTysiabuttoniconFillPrimaryActive : type === "secondary" && hovered ? dtTysiabuttoniconFillSecondaryHovered : type === "secondary" && selected ? dtTysiabuttoniconFillSecondarySelected : type === "secondary" && disabled ? dtTysiabuttoniconFillSecondaryDisabled : type === "secondary" ? dtTysiabuttoniconFillSecondaryActive : type === "critical" && hovered ? dtTysiabuttoniconFillCriticalHovered : type === "critical" && selected ? dtTysiabuttoniconFillCriticalSelected : type === "critical" && disabled ? dtTysiabuttoniconFillCriticalDisabled : type === "critical" ? dtTysiabuttoniconFillCriticalActive : type === "ghost" && hovered ? dtTysiabuttoniconFillGhostHovered : type === "ghost" && selected ? dtTysiabuttoniconFillGhostSelected : type === "ghost" && disabled ? dtTysiabuttoniconFillGhostDisabled : type === "ghost" ? dtTysiabuttoniconFillGhostActive : dtTysiabuttoniconFillPrimaryActive}
 marginLeft={marginLeft}
 marginRight={marginRight}
 width={dtSpaceS}
 height={dtSpaceS}
>
{children}
</Children>
</React.Fragment>)
}